import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { FieldglassReferenceDataProvider } from '../shared/context/FieldglassReferenceDataProvider'
import { FieldglassIssueActionsProvider } from '../shared/context/FieldglassIssueActionsProvider'
import { FieldglassShiftIssuesProvider } from './context/FieldglassShiftIssuesProvider'
import { FieldglassShiftIssuesMain } from './components/FieldglassShiftIssuesMain'

export const FieldglassShiftIssues = () => {
  return (
    <NuqsAdapter>
      <FieldglassReferenceDataProvider>
        <FieldglassIssueActionsProvider>
          <FieldglassShiftIssuesProvider>
            <FieldglassShiftIssuesMain />
          </FieldglassShiftIssuesProvider>
        </FieldglassIssueActionsProvider>
      </FieldglassReferenceDataProvider>
    </NuqsAdapter>
  )
}
